// ════════════════════════════════════════════════════════════
// App Store (Zustand) — ECR
// ════════════════════════════════════════════════════════════
// État UI global persistant entre sessions :
//   - theme (light / dark / system)
//
// L'état du shell (sidebarCollapsed, recentPages) est dans
// useShellStore. L'état d'auth (session, profile) dans useAuthStore.
// ════════════════════════════════════════════════════════════
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

interface AppState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => {
        set({ theme });
      },
    }),
    {
      name: 'ecr-app-state',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
